import React from "react";
import "../styles/general.scss";
import PropTypes from 'prop-types';
import {Grid, Button} from "@material-ui/core";
import {UIColors} from "../config/UIConfig";
import {absorbEvent} from "../utilities/Utilities";

class PosterPage extends React.Component
{
    constructor(props) {
        super(props);

        this.state = {
            posterCombo: [],
            preState: true
        };

        this.poster = React.createRef();

        this.currentPoster = 0;

        this.changePoster = this
            .changePoster
            .bind(this);

        this.enterPostState = this
            .enterPostState
            .bind(this);

        this.getVoucherPage = this
            .getVoucherPage
            .bind(this);

        this.getShopPage = this
            .getShopPage
            .bind(this);

        this.sendVoucherTracking = this
            .sendVoucherTracking
            .bind(this);

        this.sendShopTracking = this
            .sendShopTracking
            .bind(this);
    }

    componentDidMount()
    {
    }

    canvas2Image(canvas, width, height) {
        const retCanvas = document.createElement('canvas');

        const retCtx = retCanvas.getContext('2d');

        retCanvas.width = width;

        retCanvas.height = height;

        retCtx.drawImage(canvas, 0, 0, width, height, 0, 0, width, height);

        const img = document.createElement('img');

        img.src = retCanvas.toDataURL('image/jpeg'); // 可以根据需要更改格式

        return img;

    }

    changePoster(mode)
    {
        if (this.props.clickEnabled) {
            var nextPoster = this.currentPoster + (mode === 0
                ? -1
                : 1);
            if (nextPoster < 0) {
                nextPoster = this.props.posterCombo.length - 1;
            }
            if (nextPoster >= this.props.posterCombo.length) {
                nextPoster = 0;
            }
            this.currentPoster = nextPoster;
            this.setState({});
        }
    }

    enterPostState()
    {
        window.sendTracking("page", "pageview", "final");
        if (this.props.clickEnabled) {
            this.setState({preState: false});
        }
    }

    getVoucherPage()
    {
        return this.props.shop === 0
            ? "https://w.url.cn/s/AEyfLHI#wechat_redirect"
            : "https://w.url.cn/s/A8ljbIH#wechat_redirect";
    }

    getShopPage()
    {
        return this.props.shop === 0
            ? "https://vwop-open.crv.com.cn/third-oauth/third/oauth/third-redirect?thirdCode=crvOle&appId=wxf7aca64e5fd0c0dc&thirdParams=aHR0cDovL3dlaXhpbi5jcnZvbGUuY29tLmNuLy9vbGVTdGF0aWNzL3BhZ2VzL3RvUGFnZS5qc3g/dXJsSWQ9RkcyMDIxMDcyMg==#wechat_redirect"
            : "https://vwop-open.crv.com.cn/third-oauth/third/oauth/third-redirect?thirdCode=crvBlt&appId=wxc4f429b15c1fe7a1&thirdParams=aHR0cHM6Ly9ibHQtd2VpeGluLmNydm9sZS5jb20uY24vL29sZVN0YXRpY3MvcGFnZXMvdG9QYWdlLmpzeD91cmxJZD1GRzIwMjEwNzIyYmx0#wechat_redirect";
    }

    sendVoucherTracking()
    {
        window.sendTracking("click", "btn", this.props.shop === 0
            ? "final/coupon_ole"
            : "final/coupon_blt");
    }

    sendShopTracking()
    {
        window.sendTracking("click", "btn", this.props.shop === 0
            ? "final/shop_ole"
            : "final/shop_blt");
    }

    render()
    {
        return (
            <div
                style={{
                width: "100vw",
                height: "100vh",
                overflow: "hidden",
                backgroundColor: UIColors.backgroundNew
            }}>
                <Grid container direction="row">
                    <Grid item>
                        <div
                            style={{
                            width: "100vw",
                            height: "100vh"
                        }}>
                            <Grid
                                container
                                direction="row"
                                style={{
                                height: "100vh",
                                width: "100vw",
                                display: "flex"
                            }}>
                                <div
                                    style={{
                                    width: "12.5vw",
                                    alignSelf: "center",
                                    display: "flex",
                                    justifyContent: "flex-end"
                                }}>
                                    <img
                                        id="poster"
                                        onTouchStart={() => this.changePoster(0)}
                                        onTouchEnd={absorbEvent}
                                        onTouchMove={absorbEvent}
                                        onTouchCancel={absorbEvent}
                                        src={`data:image/png;base64, ${this.props.previousPosterButtonImage}`}
                                        alt="Previous button"
                                        style={{
                                        width: "5vw",
                                        height: "5vw",
                                        visibility: this.state.preState
                                            ? "visible"
                                            : "hidden"
                                    }}/>
                                </div>
                                <div
                                    style={{
                                    width: "50vw",
                                    height: "100vh",
                                    display: "flex",
                                    justifyContent: "center"
                                }}>
                                    <Grid
                                        container
                                        direction="column"
                                        style={{
                                        maxWidth: "95%",
                                        maxHeight: "95%",
                                        alignSelf: "center"
                                    }}>
                                        <Grid
                                            item
                                            style={{
                                            display: "flex",
                                            justifyContent: "center"
                                        }}><img
                                            ref={this.poster}
                                            id={this.state.preState
                ? ""
                : "poster"}
                                            src={`${this.state.preState
                ? "data:image/png;base64, "
                : ""}${this.props.posterCombo[this.currentPoster][this.state.preState
                        ? "pre"
                        : "post"]}`}
                                            alt="Poster"
                                            style={{
                maxWidth: "95%",
                maxHeight: "85vh",
                alignSelf: "center"
            }}/></Grid>
                                        <Grid
                                            item
                                            style={{
                                            display: "flex",
                                            justifyContent: "center"
                                        }}><img
                                            src={`data:image/png;base64, ${this.props.tipsImage}`}
                                            alt="Tips"
                                            style={{
                maxWidth: "20vw",
                maxHeight: "5vh",
                marginTop: "5vh",
                visibility: this.state.preState
                    ? "hidden"
                    : "visible",
                objectFit: "contain"
            }}/></Grid>
                                    </Grid>
                                </div>
                                {this.state.preState
                                    ? <div
                                            style={{
                                            width: "12.5vw",
                                            alignSelf: "center",
                                            display: "flex",
                                            justifyContent: "flex-start"
                                        }}>
                                            <img
                                                id="poster"
                                                onTouchStart={() => this.changePoster(1)}
                                                onTouchEnd={absorbEvent}
                                                onTouchMove={absorbEvent}
                                                onTouchCancel={absorbEvent}
                                                src={`data:image/png;base64, ${this.props.nextPosterButtonImage}`}
                                                alt="Next button"
                                                style={{
                                                width: "5vw",
                                                height: "5vw",
                                                visibility: this.state.preState
                                                    ? "visible"
                                                    : "hidden",
                                                marginLeft: "2.5w"
                                            }}/>
                                        </div>
                                    : null}
                                <div
                                    style={{
                                    height: "100vh",
                                    width: `${this.state.preState
                                        ? 30
                                        : 35}vw`,
                                    position: "fixed",
                                    right: 0,
                                    display: "flex",
                                    justifyContent: "center",
                                    pointerEvents: "none",
                                    marginRight: "5vh"
                                }}>
                                    <img
                                        src={this.state.preState
                                        ? `data:image/png;base64, ${this.props.contentPreImage}`
                                        : `data:image/png;base64, ${this.props.contentPostImage}`}
                                        alt="Content"
                                        style={{
                                        maxWidth: "75%",
                                        maxHeight: "100vh",
                                        placeSelf: "center",
                                        pointerEvents: "none"
                                    }}/>
                                </div>
                                <Grid
                                    container
                                    direction="column"
                                    style={{
                                    width: `${this.state.preState
                                        ? 30
                                        : 35}vw`,
                                    height: "40vh",
                                    position: "fixed",
                                    bottom: 0,
                                    right: 0,
                                    display: "flex",
                                    marginRight: "5vh",
                                    marginBottom: "2.5vh"
                                }}>
                                    <Grid
                                        container
                                        direction="row"
                                        style={{
                                        display: "flex",
                                        width: "90%",
                                        justifyContent: "center",
                                        alignSelf: "center"
                                    }}>
                                        {this.state.preState
                                            ? <Button
                                                    disabled={!this.props.clickEnabled}
                                                    disableRipple={true}
                                                    disableFocusRipple={true}
                                                    disableTouchRipple={true}
                                                    disableElevation={true}
                                                    onClick={this.enterPostState}
                                                    onTouchStart={absorbEvent}
                                                    onTouchEnd={absorbEvent}
                                                    onTouchMove={absorbEvent}
                                                    onTouchCancel={absorbEvent}
                                                    style={{
                                                    width: "100%",
                                                    backgroundColor: "transparent"
                                                }}><img
                                                    src={`data:image/png;base64, ${this.props.nextPageButtonImage}`}
                                                    alt="Next step"
                                                    style={{
                                                    maxWidth: "50%",
                                                    maxHeight: "10vh"
                                                }}/></Button>
                                            : <Grid
                                                container
                                                direction="row"
                                                style={{
                                                alignSelf: "center"
                                            }}>
                                                <Grid
                                                    item
                                                    xs={6}
                                                    style={{
                                                    maxHeight: "10vh",
                                                    backgroundColor: "transparent",
                                                    display: "flex",
                                                    justifyContent: "center",
                                                }}>
                                                    <a
                                                        style={{
                                                        maxHeight: "10vh",
                                                        backgroundColor: "transparent",
                                                        display: "flex",
                                                        justifyContent: "flex-end",
                                                        marginRight: "0.5vw"
                                                    }}
                                                        onClick={this.sendVoucherTracking}
                                                        href={this.props.clickEnabled
                                                        ? this.getVoucherPage()
                                                        : ""}><img
                                                        src={`data:image/png;base64, ${this.props.enterVoucherButtonImage}`}
                                                        alt="Voucher button"
                                                        style={{
                                                maxHeight: "10vh",
                                                maxWidth: "100%",
                                                objectFit: "contain"
                                            }}/></a>
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={6}
                                                    style={{
                                                    maxHeight: "10vh",
                                                    backgroundColor: "transparent",
                                                    display: "flex",
                                                    justifyContent: "center"
                                                }}>
                                                    <a
                                                        style={{
                                                        maxHeight: "10vh",
                                                        backgroundColor: "transparent",
                                                        display: "flex",
                                                        justifyContent: "flex-start",
                                                        marginLeft: "0.5vw"
                                                    }}
                                                        onClick={this.sendShopTracking}
                                                        href={this.props.clickEnabled
                                                        ? this.getShopPage()
                                                        : ""}><img
                                                        src={`data:image/png;base64, ${this.props.enterShopButtonImage}`}
                                                        alt="Shop button"
                                                        style={{
                                                maxHeight: "10vh",
                                                maxWidth: "100%",
                                                objectFit: "contain"
                                            }}/></a>
                                                </Grid>

                                            </Grid>}
                                    </Grid>
                                </Grid>
                            </Grid>
                        </div>
                    </Grid>
                </Grid>
                <img
                    src={`data:image/png;base64, ${this.props.titleImage}`}
                    alt={"Title"}
                    style={{
                    zIndex: 10,
                    position: "absolute",
                    right: "2.5vw",
                    top: 0,
                    maxHeight: "15vh",
                    maxWidth: "30vw"
                }}/>
            </div>
        );
    }
}

PosterPage.propTypes = {
    posterCombo: PropTypes.array,
    contentPreImage: PropTypes.string,
    contentPostImage: PropTypes.string,
    tipsImage: PropTypes.string,
    nextPageButtonImage: PropTypes.string,
    enterShopButtonImage: PropTypes.string,
    enterVoucherButtonImage: PropTypes.string,
    previousPosterButtonImage: PropTypes.string,
    nextPosterButtonImage: PropTypes.string,
    clickEnabled: PropTypes.bool
};

PosterPage.defaultProps = {
    posterCombo: [],
    contentPreImage: "",
    contentPostImage: "",
    tipsImage: "",
    nextPageButtonImage: "",
    enterShopButtonImage: "",
    enterVoucherButtonImage: "",
    previousPosterButtonImage: "",
    nextPosterButtonImage: "",
    clickEnabled: false
};

export default PosterPage;